const currentYear: number = (new Date()).getFullYear();
export default currentYear;
